import ImagePortfolio1 from "../../assets/porfolio images/portfolio 1.jpg";
import ImagePortfolio2 from "../../assets/porfolio images/portfolio 2.jpg";
import ImagePortfolio3 from "../../assets/porfolio images/portfolio 3.jpg";


const data = [
  {
    id: 1,
    img: ImagePortfolio1,
    title: "My Work",
    desc: " just for practise more coming .",
  },
  {
    id: 2,
    img:ImagePortfolio2 ,
    title: "My Work",
    desc: "just for practise more coming.",
  },
  {
    id: 3,
    img:ImagePortfolio3,
    title: "My Work",
    desc: " just for practise more coming.",
  },
];

export default data;
